import React from "react";
import PropTypes from "prop-types";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";

const IMG_SIZES = {
	large: { width: 1920, height: 630 },
	xlarge: { width: 1920, height: 630 },
	medium: { width: 1920, height: 630 },
	small: { width: 750 },
};

const ListingCover = ({
	imgLargeSrc,
	imgLargeThumbnail,
	imgSmallSrc,
	imgSmallThumbnail,
	resolution,
}) => {
	const isSmall = resolution === RESOLUTION.SMALL;

	return isSmall ? (
		<ProgressiveImg
			sizes={IMG_SIZES}
			resolution={resolution}
			src={imgSmallSrc}
			thumbnail={imgSmallThumbnail}
			quality="q_auto:best"
		/>
	) : (
		<BackgroundProgressiveImg
			sizes={IMG_SIZES}
			resolution={resolution}
			src={imgLargeSrc}
			thumbnail={imgLargeThumbnail}
			quality="q_auto:best"
			backgroundPosition="center"
		/>
	);
};

ListingCover.propTypes = {
	imgLargeSrc: PropTypes.string,
	imgSmallSrc: PropTypes.string,
	imgLargeThumbnail: PropTypes.string,
	imgSmallThumbnail: PropTypes.string,
	resolution: resolutionPropType,
};

export default React.memo(ListingCover);
